import { useMutation } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';

export const useDownloadOrderInvoiceMutation = () => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (orderId: string) => {
      const token = await getToken();
      return downloadOrderInvoice(orderId, token ?? '');
    },
  });
};

const downloadOrderInvoice = async (orderId: string, token: string): Promise<void> => {
  const url = `${import.meta.env.VITE_API_URL}/transactions/order/${orderId}/invoice`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to download invoice');
  }

  // streamed response from backend
  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);

  const newTab = window.open(downloadUrl, '_blank', 'noopener,noreferrer');
  if (newTab) {
    newTab.addEventListener('load', () => window.URL.revokeObjectURL(downloadUrl));
  } else {
    window.URL.revokeObjectURL(downloadUrl);
  }
};

export default useDownloadOrderInvoiceMutation;
